import type { TeamMember } from '@/types/doctor'

export const clinicalTeam: TeamMember[] = [
  // Hijab
  {
    id: 2,
    name: 'Hijab Bilgrami',
    title: 'Psychologist',
    role: 'Psychologist',
    imageUrl: '/images/team/hijab.avif',
    cutOutUrl: '/bg-removed/hijab.avif',
    specialty: 'Cognitive Behavioral Therapy',
    yearsExperience: 6,

    credentials: [
      'DHA (Dubai Health Authority): 25711565',
      'APA (American Psychological Association): C240947718',
      'CCI (Counsellors Council of India): CRN4141717',
    ],

    // ⬇️ two-bucket expertise
    expertise: {
      children: [
        'Anxiety disorders',
        'Depressive disorders',
        'Couples counselling',
        'Stress management',
        'Grief',
        'Trauma',
        'Neurodevelopmental disorders – ADHD, Autism Spectrum Disorders',
      ],
      adults: [
        'Surrogacy evaluations',
        'Aggression',
        'Impulsive behavior',
        'Attention and concentration difficulties',
        'School difficulties/refusal',
        'Loss/grief',
        'Coping with parents’ divorce',
        'Trauma',
      ],
    },

    languagesKnown: ['English', 'Hindi', 'Urdu'],

    bio: 'Hijab provides therapy for children, adolescents and adults at ReACH Psychiatry and Counselling Centre, Bangalore. Her area of expertise includes working with adolescents and adults with a multitude of concerns ranging from anxiety and depression, to psychosis, and neurodevelopmental disorders. She also works with children with behavioural problems, learning issues, and intensively works with students providing appropriate study strategies, time management skills and dealing with stress and anxiety related to their academics. Hijab has experience in psychological assessments and psychotherapy for a wide range of disorders. She is well versed in Cognitive behavioural Therapy (CBT), Dialectical Behavioural Therapy (DBT), ADHD Coaching, and Trauma Therapy. She incorporates different therapeutic techniques and helps in resolving their problems pertaining to emotional, behavioural and social adjustments. Hijab also utilizes Mindfulness Based Cognitive Therapy, Solution focused approach during her sessions to ensure realistic change in each individual’s mental health. She also administers the Neuro-feedback Training procedures to her clients to help them with their focus and attention issues; Transcranial Magnetic Stimulation for mood issues and other relaxation procedures to help her clients with sleep issues, stress management and adjustment issues. She has good experience in assessments and testing and can sketch a plan of action based on her evaluations.',
    philosophy:
      "I believe in empowering clients with practical tools and strategies they can use to navigate life's challenges independently.",
  },

  // Grace
  {
    id: 3,
    name: 'Grace Priscilla',
    title: 'Psychologist',
    role: 'Psychologist',
    imageUrl: '/images/team/grace.avif',
    cutOutUrl: '/bg-removed/grace.avif',
    specialty: 'Trauma & Crisis Intervention',
    yearsExperience: 6,

    credentials: [
      'DHA (Dubai Health Authority): 71038524-002',
      'APA (American Psychological Association): C2404948185',
      'CCI (Counsellors Council of India): CRN6007900',
    ],

    languagesKnown: ['English', 'Hindi', 'Tamil', 'Malayalam'],

    expertise: {
      children: [
        'Anxiety disorders',
        'Depressive disorders',
        'Couples counselling',
        'Stress management',
        'Grief',
        'Trauma',
        'Neurodevelopmental disorders – ADHD, Autism Spectrum Disorders',
      ],
      adults: [
        'Surrogacy evaluations',
        'Aggression',
        'Impulsive behavior',
        'Attention and concentration difficulties',
        'School difficulties/refusal',
        'Loss/grief',
        'Coping with parents’ divorce',
        'Trauma',
      ],
    },

    bio: "Grace Priscilla is a licensed Clinical Psychologist with experience in the field of mental health. She is dedicated to providing personalized and evidence-based mental health services and to help clients navigate life's twists and turns with a mix of empathy and expertise. Her approach is rooted in evidence based therapeutic techniques and committed to providing treatment to individuals based on their unique needs and goals. She is specialized in assessing, diagnosing, and treating of a wide range of mental health disorders such as Anxiety, Depression, Neurodevelopmental Disorders like ADHD, and ASD. In particular, her expertise lies in utilizing evidence-based modalities such as CBT, DBT, ADHD Coaching and Mindfulness-Based Therapy to help individuals achieve their therapeutic goals. She also administers the Neuro-feedback Training procedures to her clients to help them with their focus and attention issues; Transcranial Magnetic Stimulation for mood issues and other relaxation procedures to help her clients with sleep issues, stress management and adjustment issues. She has good experience in assessments and testing and can sketch a plan of action based on her evaluations.",
    philosophy:
      'Healing from trauma is possible. With the right support and evidence-based techniques, we can transform pain into growth.',
  },

  // Rachana
  {
    id: 4,
    name: 'Rachana Kulkarni',
    title: 'Psychologist',
    role: 'Psychologist',
    imageUrl: '/images/team/rachana.avif',
    cutOutUrl: '/bg-removed/rachana.avif',
    specialty: 'Child & Family Psychology',
    yearsExperience: 6,

    credentials: [
      'APA (American Psychological Association): C2404948209',
      'CCI (Counsellors Council of India): CRN5818249',
    ],

    languagesKnown: ['English', 'Hindi', 'Kannada'],

    expertise: {
      children: [
        'Anxiety disorders',
        'Depressive disorders',
        'Couples counselling',
        'Stress management',
        'Grief',
        'Trauma',
        'Neurodevelopmental disorders – ADHD, Autism Spectrum Disorders',
      ],
      adults: [
        'Surrogacy evaluations',
        'Aggression',
        'Impulsive behavior',
        'Attention and concentration difficulties',
        'School difficulties/refusal',
        'Loss/grief',
        'Coping with parents’ divorce',
        'Trauma',
      ],
    },

    bio: 'Rachana offers therapy for individuals, couples, and families at ReACH Psychiatric Clinics. Rachana is passionate about helping both adolescents and adults with ADHD reach their potential, she is also passionate about working with adults experiencing anxiety and mood issues, and life stressors and transitions. Rachana tailor-makes her approach with each client to suit their individual needs, she is empathetic and understanding towards each person’s needs. She provides Cognitive Behavioural Therapy, Dialectical Behavioural Therapy, ADHD Coaching, and supportive counselling for issues such as Mood disorders, Anxiety Disorders, Communication or relationship problems, neurodevelopmental disorders, work and school frustrations among others. Rachana also utilizes Mindfulness Based Cognitive Therapy, Solution focused approach during her sessions to ensure realistic change in each individual’s mental health. She also administers the Neuro-feedback Training procedures to her clients to help them with their focus and attention issues; Transcranial Magnetic Stimulation for mood issues and other relaxation procedures to help her clients with sleep issues, stress management and adjustment issues. She has good experience in assessments and testing and can sketch a plan of action based on her evaluations.',
  },

  // Sanjana
  {
    id: 5,
    name: 'Sanjana Kale',
    title: 'Psychologist',
    role: 'Psychologist',
    imageUrl: '/images/team/sanjana.avif',
    cutOutUrl: '/bg-removed/sanjana.avif',
    specialty: 'Teen Mental Health',
    yearsExperience: 2,

    languagesKnown: ['English', 'Hindi', 'Kannada', 'Marathi'],

    expertise: {
      children: [
        'Neurodevelopmental disorders – ADHD, Autism Spectrum Disorders',
        'Academic stress and anxiety',
        'Study strategies and time management',
        'Behavioral and emotional difficulties',
        'Attention and concentration issues',
        'Emotional regulation and self-awareness',
      ],
      adults: [
        'Depressive disorders',
        'Anxiety disorders',
        'Obsessive-Compulsive Disorder (OCD)',
        'Mood disorders',
        'Stress management',
      ],
    },
    bio: 'Sanjana provides therapy for children, adolescents, and adults, helping individuals navigate various mental health challenges at ReACH Psychiatry and Counselling Centre, Bangalore. Her area of expertise includes working with individuals experiencing anxiety, depression, Obsessive-Compulsive Disorder (OCD), ADHD, mood disorders, and neurodevelopmental disorders such as Autism Spectrum Disorder (ASD). She also provides support for stress management, emotional regulation, and personal growth, ensuring her clients develop effective coping mechanisms to manage their mental well-being. Sanjana has experience in psychological assessments and psychotherapy for a wide range of disorders. She is well-versed in Cognitive Behavioral Therapy (CBT) and adopts a person-centered approach to create tailored treatment plans for each individual. She prioritizes building a trusting and supportive environment where clients can openly express themselves without fear of judgment. Her sessions focus on fostering self-awareness, emotional regulation, and resilience to help individuals navigate life’s challenges effectively. She also conducts psychological and psychoeducational assessments for ADHD, Autism Spectrum Disorder, and other developmental disorders to provide structured evaluations and treatment plans.',
  },
]
